import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Pending.css';
import DemoFeedbackModal from './DemoFeedbackModal';
import PaidFeedbackModal from './PaidFeedbackModal';

const Pending = ({ userData, day, onSubmitrefresh }) => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchPendingFeedbacks = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/teacher/teacherfeedback/${userData.id}`
        );
        setFeedbacks(response.data.pendingFeedbacks);
        setError(null);
      } catch (err) {
        setError(err.message || 'Failed to fetch pending feedbacks');
        setFeedbacks([]);
      } finally {
        setLoading(false);
      }
    };

    if (userData?.id) {
      fetchPendingFeedbacks();
    }
  }, [day, userData]);

  const handleSubmitFeedback = (feedback) => {
    setSelectedFeedback({
      ...feedback,
      IdSchedule: feedback.Id,
      IdTeacher: userData.id,
      IdStudent: feedback.IdUser
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedFeedback(null);
  };

  const handleSubmitSuccess = () => {
    const fetchPendingFeedbacks = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/teacher/teacherfeedback/${userData.id}`
        );
        setFeedbacks(response.data.pendingFeedbacks);
        onSubmitrefresh();
      } catch (err) {
        console.error('Error refreshing feedbacks:', err);
      }
    };
    fetchPendingFeedbacks();
  };

  const formatDate = (dateString) => {
    const options = { weekday: 'short', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const formatTime = (dateString) => {
    const options = { hour: '2-digit', minute: '2-digit', hour12: true };
    return new Date(dateString).toLocaleTimeString(undefined, options);
  };

  if (loading) {
    return (
      <div className="teacherportal-pending-loading">
        <div className="teacherportal-spinner"></div>
        <p>Loading pending feedbacks...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="teacherportal-pending-error">
        <p>Error: {error}</p>
        <button onClick={() => window.location.reload()}>Try Again</button>
      </div>
    );
  }

  if (feedbacks.length === 0) {
    return (
      <div className="pending-empty">
        <p>No pending feedbacks found</p>
      </div>
    );
  }

  return (
    <div className="teacherportal-pending-container">
      
      
      <div className="teacherportal-pending-list">
        {feedbacks.map((feedback, index) => (
          <div key={index} className="teacherportal-feedback-card">
            <div className="teacherportal-feedback-main">
              <div className="teacherportal-feedback-student">
                <img 
                  src={feedback.Image} 
                  alt={`${feedback.FirstName} ${feedback.LastName}`}
                  className="teacherportal-student-avatar"
                />
                <div className="teacherportal-student-details">
                  <h3 className="teacherportal-student-name">
                    {feedback.FirstName} {feedback.LastName}
                  </h3>
                  <div className="teacherportal-class-info">
                    <span className={`teacherportal-class-badge ${feedback.Type === 0 ? 'teacherportal-paid' : 'teacherportal-demo'}`}>
                      {feedback.Type === 0 ? 'Paid' : 'Demo'}
                    </span>
                    <div className="teacherportal-datetime">
                      <span className="teacherportal-date">{formatDate(feedback.ClassDateTime)}</span>
                      <span className="teacherportal-time">{formatTime(feedback.ClassDateTime)}</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <button 
                className="teacherportal-submit-btn"
                onClick={() => handleSubmitFeedback(feedback)}
              >
                Submit Feedback
              </button>
            </div>
          </div>
        ))}
      </div>

      {showModal && selectedFeedback && selectedFeedback.Type === 1 && (
        <DemoFeedbackModal
          feedback={selectedFeedback}
          onClose={handleCloseModal}
          onSubmitSuccess={handleSubmitSuccess}
        />
      )}

      {showModal && selectedFeedback && selectedFeedback.Type === 0 && (
        <PaidFeedbackModal
          feedback={selectedFeedback}
          onClose={handleCloseModal}
          onSubmitSuccess={handleSubmitSuccess}
        />
      )}
    </div>
  );
};

export default Pending;